<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Venue Setup</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideCancel]="true"
				[hideDelete]="true"
				(onSaveChange)="onSave()"
				[saveDisabled]="!changesToSave"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-tabView>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'store']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Store</div>
			</ng-template>
			<app-general-store-setup [(changesToSave)]="changesToSave"></app-general-store-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'comment-lines']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Messaging</div>
			</ng-template>
			<app-general-messaging-setup [(changesToSave)]="changesToSave"></app-general-messaging-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'hand-holding-box']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Order</div>
			</ng-template>
			<app-general-order-handling-setup [(changesToSave)]="changesToSave"></app-general-order-handling-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'desktop']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">Display</div>
			</ng-template>
			<app-general-display-setup [(changesToSave)]="changesToSave"></app-general-display-setup>
		</p-tabPanel>
		<p-tabPanel headerStyleClass="p-tab-header">
			<ng-template pTemplate="header">
				<fa-icon [icon]="['far', 'cash-register']" size="lg" class="ms-1"></fa-icon>
				<div class="mx-2">POS</div>
			</ng-template>
			<app-general-pos-setup [(changesToSave)]="changesToSave" [(changesToOoMenuConfig)]="changesToOoMenuConfig"></app-general-pos-setup>
		</p-tabPanel>
	</p-tabView>
</div>
